/* ==========================================================================
   MARIA MODESTA - SIZE TABLE AUTOMATIC ASCENDING SORTER (assets/size-table-sorter.js)
   ========================================================================== */

(function () {
  'use strict';

  const SIZE_WEIGHTS = {
    'XXS': 10,
    'XS': 20,
    'XS/S': 25,
    'S': 30,
    'S/M': 35,
    'M': 40,
    'M/L': 45,
    'L': 50,
    'L/XL': 55,
    'XL': 60,
    'XL/XXL': 65,
    'XXL': 70,
    '2XL': 70,
    '2XL/3XL': 75,
    'XXL/3XL': 75,
    '3XL': 80,
    '4XL': 90,
    '5XL': 100,
    'TAMANHO ÚNICO': 999,
    'ONE SIZE': 999
  };

  function getSizeWeight(sizeStr) {
    if (!sizeStr) return 9999;
    const clean = sizeStr.trim().toUpperCase();

    // 1. Direct match in dictionary
    if (SIZE_WEIGHTS[clean] !== undefined) {
      return SIZE_WEIGHTS[clean];
    }

    // 2. Extract numeric values (e.g., "36", "36/37", "40 cm")
    const match = clean.match(/(\d+)/);
    if (match) {
      return parseInt(match[1], 10);
    }

    return 9999;
  }

  function sortProductTables() {
    const tables = document.querySelectorAll('.prod_table, table');

    tables.forEach(table => {
      const rows = Array.from(table.querySelectorAll('tr'));
      if (rows.length < 2) return;

      // Identify header row vs data rows
      let headerRow = null;
      let dataRows = [];

      rows.forEach(row => {
        if (row.querySelector('th') || row.parentNode.tagName === 'THEAD') {
          headerRow = row;
        } else {
          dataRows.push(row);
        }
      });

      if (dataRows.length < 2) return;

      // Sort data rows based on first cell content (Size label)
      dataRows.sort((a, b) => {
        const cellA = a.children[0] ? a.children[0].textContent : '';
        const cellB = b.children[0] ? b.children[0].textContent : '';
        return getSizeWeight(cellA) - getSizeWeight(cellB);
      });

      // Re-append sorted rows into table/tbody
      const container = table.querySelector('tbody') || table;
      dataRows.forEach(row => container.appendChild(row));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortProductTables);
  } else {
    sortProductTables();
  }
})();
